"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var icons_1 = require("../../../icons");
var style_1 = require("../../../style");
var input_1 = require("../../input");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var FeaturedIcon_1 = __importDefault(require("../FeaturedIcon"));
var styles_1 = require("./styles");
var CloseButton_1 = __importDefault(require("../../buttons/CloseButton"));
var DIALOG_TYPE_TO_ICON = {
    success: icons_1.CheckCircle,
    warning: icons_1.AlertTriangle,
    error: icons_1.AlertCircle,
};
var DIALOG_TYPE_TO_COLOR = {
    standard: 'Gray',
    primary: 'Primary',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
};
var getIconByType = function (type, icon) {
    if (type === void 0) { type = 'standard'; }
    var renderedIcon = icon || DIALOG_TYPE_TO_ICON[type];
    if (renderedIcon) {
        return (react_1.jsx(FeaturedIcon_1.default, { theme: "light-circle-outline", icon: renderedIcon, color: DIALOG_TYPE_TO_COLOR[type] }));
    }
    return null;
};
var Dialog = function (_a) {
    var title = _a.title, description = _a.description, type = _a.type, icon = _a.icon, onCancel = _a.onCancel, onConfirm = _a.onConfirm, confirmText = _a.confirmText, cancelText = _a.cancelText, size = _a.size, cancelProps = _a.cancelProps, confirmProps = _a.confirmProps, children = _a.children;
    var styles = react_2.useMemo(function () { return styles_1.createDialogStyles(size); }, [size]);
    var renderedIcon = react_2.useMemo(function () { return getIconByType(type, icon); }, [type, icon]);
    return (react_1.jsx(layout_1.Flex, { direction: "column", gap: 32, css: styles.container },
        react_1.jsx(CloseButton_1.default, { onClick: onCancel, css: styles.close }),
        react_1.jsx(layout_1.Flex, { direction: "column", gap: 20 },
            renderedIcon,
            react_1.jsx(layout_1.Flex, { direction: "column", gap: 8 },
                react_1.jsx(Text_1.default.Body, { css: !renderedIcon ? styles.titleNoIcon : undefined, size: "lg", weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_4 }, title),
                description ? (react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DEFAULT }, description)) : null),
            children),
        react_1.jsx(layout_1.Flex, { gap: 12, justifyContent: "flex-end" },
            react_1.jsx(input_1.Button, __assign({ type: "button", onClick: onCancel, variant: "secondary" }, cancelProps), cancelText || 'Cancel'),
            react_1.jsx(input_1.Button, __assign({ onClick: onConfirm, destructive: type === 'error' }, confirmProps), confirmText || 'Confirm'))));
};
exports.default = Dialog;
